define("shared/components/shared/post-tagging/badge", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{! @glint-expect-error: BasicDropdown not typed }}
    <BasicDropdown @preventScroll={{true}} as |dd|>
      <dd.Trigger
        @stopPropagation={{true}}
        class={{concat-classes "cPT__badge" "u--p__l__sm" "u--cursor" @class}}
        data-test-id="badge-dropdown-trigger"
        tabindex="0"
      >
        {{#if (has-block "dropdownTrigger")}}
          {{yield to="dropdownTrigger"}}
        {{else}}
          {{#if @color}}
            <Shared::PostTagging::ColorCircle @color={{@color}} />
          {{/if}}
          <span class="cPT__badge__text u--m__l__m" data-test-id="badge-text">{{@text}}</span>
        {{/if}}
      </dd.Trigger>
      <dd.Content class="cPT__badge-dropdown__content" data-test-id="badge-dropdown-content">
        {{yield (hash text=@text color=@color class=@class)}}
      </dd.Content>
    </BasicDropdown>
  {{else}}
    <div class={{concat-classes "cPT__badge" "u--p__l__sm" @class}} data-test-id="badge-noDropdown-wrapper">
      {{#if @color}}
        <Shared::PostTagging::ColorCircle @color={{@color}} />
      {{/if}}
      <span class="cPT__badge__text u--m__l__m" data-test-id="badge-text">{{@text}}</span>
    </div>
  {{/if}}
  */
  {
    "id": "GOalqhuo",
    "block": "[[[41,[48,[30,5]],[[[1,\"  \"],[8,[39,2],null,[[\"@preventScroll\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"Trigger\"]],[[16,0,[28,[37,3],[\"cPT__badge\",\"u--p__l__sm\",\"u--cursor\",[30,2]],null]],[24,\"data-test-id\",\"badge-dropdown-trigger\"],[24,\"tabindex\",\"0\"]],[[\"@stopPropagation\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"        \"],[18,6,null],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"          \"],[8,[39,5],null,[[\"@color\"],[[30,3]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,1],[14,0,\"cPT__badge__text u--m__l__m\"],[14,\"data-test-id\",\"badge-text\"],[12],[1,[30,4]],[13],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"Content\"]],[[24,0,\"cPT__badge-dropdown__content\"],[24,\"data-test-id\",\"badge-dropdown-content\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[18,5,[[28,[37,6],null,[[\"text\",\"color\",\"class\"],[[30,4],[30,3],[30,2]]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[15,0,[28,[37,3],[\"cPT__badge\",\"u--p__l__sm\",[30,2]],null]],[14,\"data-test-id\",\"badge-noDropdown-wrapper\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[8,[39,5],null,[[\"@color\"],[[30,3]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,1],[14,0,\"cPT__badge__text u--m__l__m\"],[14,\"data-test-id\",\"badge-text\"],[12],[1,[30,4]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"dd\",\"@class\",\"@color\",\"@text\",\"&default\",\"&dropdownTrigger\"],false,[\"if\",\"has-block\",\"basic-dropdown\",\"concat-classes\",\"yield\",\"shared/post-tagging/color-circle\",\"hash\"]]",
    "moduleName": "shared/components/shared/post-tagging/badge.hbs",
    "isStrictMode": false
  });
  const BadgeComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BadgeComponent);
});